import { render } from "./ProductRecordView.vue?vue&type=template&id=32e7f242&scoped=true"
import script from "./ProductRecordView.vue?vue&type=script&lang=js"
export * from "./ProductRecordView.vue?vue&type=script&lang=js"

import "./ProductRecordView.vue?vue&type=style&index=0&id=32e7f242&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e7f242"]])

export default __exports__